export default class Constants_ui {
    static TESTMODE = false;
    static TESTMODE_CHAT = false;
    static PAGE_START ="PageLoading";   //시작 페이지 설정
    static PAGE_LOADING ="PageLoading";
    static PAGE_AUTH ="PageAuth";
    static PAGE_MAIN ="PageMain";

    static FIRSTLOADING_TIME = 4000;
}